<template>
    <div class="all clearfix" >
        <div class="trans">
           <div class="grid pb30">
                 <div class="warp mt5 clearfix">
                    <div class="warp-body">
                        <div class="hotEvent fl" :class="{'w362':isShow}">
                            <div class="hotList" v-if="isShow">
                                <div class="grid-header clearfix">
                                    <h2 class="title fl">热点事件推荐</h2>
                                </div>
                                <div class="no-data pt40" v-if="nodata.hotAllRank"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                                <ul class="news mt10">
                                    <li v-for="(item,index) in hotAllRank" :key="index">
                                        <span class="title ovhidden cr3d cp" :title="item.news_title" @click="hotEvent(item.news_sim_hash)"><i class="order">{{index+1}}</i>{{item.news_title}}</span>
                                    </li>
                                </ul>
                            </div>
                            <span class="cp" @click="isShowList" v-if="!isShow">{{btnName}}</span>
                        </div>
                        
                        <div class="artiWrap h680 hidden">
                            <pathChart id="pathChart" :dataArray="pathData" v-if="pathData != ''"></pathChart>
                            <div class="no-data mt0 pt40" v-if="nodata.pathData"><img src="static/images/no_data.png" class="img"/><span class="text crff">啥也没有找到，换个词试试吧~</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import d3chart from '../components/d3Chart.vue'
import pathChart from '../components/pathChart.vue';
export default {
    components: {d3chart,pathChart},
    data() {
        return {
            sim:'',
            hotAllRank:[], //热点事件
            pathData:[],
            isShow:true,
            btnName:'收起',
            nodata:{
                hotAllRank:false,
                pathData:false,
            }
        }
    },
    mounted() {
        let that = this;
        that.hotAjax();
    },
    methods: {
        isShowList(){
            let that = this;
            that.btnName = that.isShow?"展开":'收起';
            that.isShow = !that.isShow
        },
        //热点事件
        hotAjax(){
            let that = this;
            that.$api.get('knowledge/hotnews/list',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    that.hotAllRank = r.data;
                    that.sim = r.data[0].news_sim_hash;
                    that.knowAjax()
                    if(r.data.length<=0){
                        that.nodata.hotAllRank = true;
                        return
                    }else{
                        that.nodata.hotAllRank = false;
                    }
                });
            });
        },
        hotEvent(item){
            let that = this;
            that.sim = item;
            that.isShowList();
            that.knowAjax();
        },
        //传播路径
        knowAjax(){
            let that = this;
            let datas = {news_sim_hash:that.sim};
            that.$api.get('knowledge/hotnews/relation',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false)
                    that.pathData  = r.data
                    if(r.data.length<=0){
                        that.nodata.pathData = true;
                        return
                    }else{
                        that.nodata.pathData = false;
                    }
               });
            });
        },
        
	}
}
</script>



// WEBPACK FOOTER //
// src/page/eventMap.vue